import {
  ClientCompanyWareHouse,
  Define,
  NotificationBell,
  Quartet,
} from './types'

export function renderDigitsByNumber(
  text: string | undefined,
  numberOfDigits: number,
  //check if render number of digits = digits want to display
  isEqual?: boolean
) {
  const NUMBER_OF_DOTS = 3
  if (!text) return '-'
  if (numberOfDigits < 3) return ''
  else if (text.length <= numberOfDigits) return text
  else if (isEqual) return `${text.substring(0, numberOfDigits)}...`
  else return `${text.substring(0, numberOfDigits - NUMBER_OF_DOTS)}...`
}

export function checkActive(path: string) {
  return window.location.pathname.includes(path)
}

export const activeColor = '#f09637'

export function triangleToQuartet(
  triangles: ClientCompanyWareHouse[]
): Quartet[] {
  // @ts-ignore
  return triangles.map((triangle) => ({
    ...triangle,
    user_id: localStorage.getItem(Define.USER_ID) || '',
  }))
}

// from the combine of user id, client id, warehouse id and company id to generate a uuid in firestore
export const quartetToDocId = (quartet: Quartet) =>
  `${quartet.client_id}-${quartet.warehouse_id}-${quartet.company_id}-${quartet.user_id}`

export function removeOldNoti(
  quartets: Quartet[],
  noti: Map<string, NotificationBell>
) {
  const newDocIds = quartets.map((quartet) => quartetToDocId(quartet))
  noti.forEach((value, key) => {
    if (!newDocIds.includes(key)) noti.delete(key)
  })
}

export const extractCodeAndNom = (code_nom: string): [string, string] => {
  const index = code_nom.indexOf('_')
  if (index < 0) {
    return [code_nom, code_nom]
  }
  const code = code_nom.substring(0, index)
  const nom = code_nom.substring(index + 1)
  return [code, nom]
}

export const getLocalClientCompanyWarehouse = () => {
  const localClientId = localStorage.getItem(Define.CHOOSING_CLIENT) || ''
  const localClientCodenom =
    localStorage.getItem(Define.CHOOSING_CLIENT_CODENOM) || ''
  const localCompanyId = localStorage.getItem(Define.CHOOSING_COMPANY) || ''
  const localWarehouseId = localStorage.getItem(Define.CHOOSING_WAREHOUSE) || ''
  const localCompanyCodeNom =
    localStorage.getItem(Define.CHOOSING_COMPANY_CODENOM) || ''
  const localWarehouseCodeNom =
    localStorage.getItem(Define.CHOOSING_WAREHOUSE_CODENOM) || ''
  return {
    localClientId,
    localClientCodenom,
    localCompanyId,
    localCompanyCodeNom,
    localWarehouseId,
    localWarehouseCodeNom,
  }
}

export const getLocalUserId = () => localStorage.getItem(Define.USER_ID) || ''
